import { FooterModel } from "../../core/models/FooterModel";

interface FooterProps {
    footer: FooterModel
}


function Footer(props: FooterProps) {
    const footer = props.footer;
    return (
        <>
            <div
                style={{
                    width: "100%",
                    height: 250,
                }}
            >
                <center>
                    {footer !== undefined ? (
                        <>
                            <h1
                                style={{
                                    marginTop: 40,
                                    marginBottom: 20,
                                    textAlign: "center",
                                    color: "white",
                                    fontSize: 72,
                                }}
                            >
                                {footer.title}
                            </h1>
                            <p
                                style={{
                                    marginTop: 40,
                                    marginBottom: 20,
                                    textAlign: "center",
                                    color: "white",
                                    fontWeight: "normal"
                                }}
                            >
                                {footer.description}
                            </p>
                        </>
                    ) : null}
                </center>
            </div>
        </>
    );
}

export default Footer;